/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaselineDetailDto } from '../models/BaselineDetailDto';
import type { BaselinesListResponseDto } from '../models/BaselinesListResponseDto';
import type { DiagnosticSolutionsRequestDto } from '../models/DiagnosticSolutionsRequestDto';
import type { SolutionsResponseDto } from '../models/SolutionsResponseDto';
import type { UserProfile_Output } from '../models/UserProfile_Output';

export class DiscoveryEvaluationService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * List Evaluation Baselines
   * List every baseline the discovery fixture knows about.
   * @returns BaselinesListResponseDto Successful Response
   * @throws ApiError
   */
  public listEvaluationBaselinesInternalDiscoveryEvaluationBaselinesGet(): CancelablePromise<BaselinesListResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/discovery/evaluation/baselines',
    });
  }
  /**
   * Get Evaluation Baseline
   * One baseline with its raw care-profile + ground-truth blobs.
   * @param baselineId
   * @returns BaselineDetailDto Successful Response
   * @throws ApiError
   */
  public getEvaluationBaselineInternalDiscoveryEvaluationBaselinesBaselineIdGet(
    baselineId: string
  ): CancelablePromise<BaselineDetailDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/discovery/evaluation/baselines/{baseline_id}',
      path: {
        baseline_id: baselineId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Evaluation Baseline Profile
   * The built :class:`UserProfile` for a baseline.
   *
   * Lets a presenter load a golden persona as a starting profile for the
   * inline-profile (``profile``) mode of ``POST /solutions`` — the expert
   * can then tweak fields and re-run. Reuses :func:`build_user_profile`
   * so the fixture→profile synthesis lives in exactly one place.
   * @param baselineId
   * @returns UserProfile_Output Successful Response
   * @throws ApiError
   */
  public getEvaluationBaselineProfileInternalDiscoveryEvaluationBaselinesBaselineIdProfileGet(
    baselineId: string
  ): CancelablePromise<UserProfile_Output> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/discovery/evaluation/baselines/{baseline_id}/profile',
      path: {
        baseline_id: baselineId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Solutions For Evaluation
   * Run the engine and return the full SolutionsResponseDto.
   *
   * Engine path is identical to production; the only thing that varies
   * is whether profile + inventory come from the monolith or from a
   * discovery baseline.
   *
   * Inputs are loaded from the DB at the scope determined by the chosen
   * mode — for baseline mode that's ``(baseline.employee_id, set_id)``;
   * for employee and inline-profile modes that's ``(employee_id, set_id)``
   * (the profile's own ``employee_id`` for the inline path) — unless the
   * request carries transient ``inputs``, which bypass the DB entirely
   * (see :func:`_resolve_input_set`).
   *
   * ``require_operator_role`` gates the whole route, every mode included:
   * one tier per route, not per mode, so a ``baseline_id`` call — which
   * itself never reaches the monolith — needs an operator bearer too. That
   * is also what makes the monolith-backed modes below safe: by the time
   * this body runs, ``get_logged_in_user()`` is guaranteed non-``None``, so
   * ``MonolithApiClient.get_monolith_api()`` forwards the caller's own token
   * rather than dying on a missing one.
   * @param requestBody
   * @returns SolutionsResponseDto Successful Response
   * @throws ApiError
   */
  public getSolutionsForEvaluationInternalDiscoveryEvaluationSolutionsPost(
    requestBody: DiagnosticSolutionsRequestDto
  ): CancelablePromise<SolutionsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/discovery/evaluation/solutions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
